import _ from 'lodash';

import {BASE_URL} from '../constants/config';

const LESSON_DURATION = 15; // 15 min

export const getCourseStatistics = (course) => {
  const lessons = _.get(course, 'lessons.length', 0);
  return {
    lessons,
    hours: Math.round((lessons * LESSON_DURATION) / 60),
    min: lessons * LESSON_DURATION,
  };
};

export const getTrackStatistics = (track) => {
  const stats = {
    lessons: 0,
    hours: 0,
    min: 0,
  };

  if (!track.courses) return stats;

  track.courses.forEach((course) => {
    const {lessons, hours, min} = getCourseStatistics(course);
    stats.lessons += lessons;
    stats.hours += hours;
    stats.min += min;
  });

  return stats;
};

export const getCourseTrackStatistics = (courseTrack, isCourse) => (isCourse
  ? getCourseStatistics(courseTrack)
  : getTrackStatistics(courseTrack));

export const getCanonicalUrl = (courseSlug, lessonSlug) => (
  `${BASE_URL}/courses/${courseSlug}/${lessonSlug}`
);

const addCourseSlugIntoLessons = (lessons, courseSlug) => {
  const newLessons = lessons.map((lesson) => ({...lesson, courseSlug}));
  return newLessons;
};

export const getNextAvailableLesson = ({
  courses,
  trackSlug,
  hasSubscription = false,
  from = null,
}) => {
  const availableCourses = courses.filter((c) => c.available && !c.comingSoon);
  const lessons = availableCourses.flatMap((c) => addCourseSlugIntoLessons(c.lessons, c.slug));
  const availableLessons = lessons.filter((l) => !l.comingSoon);

  let lessonsAfterFrom = availableLessons;
  if (from) {
    lessonsAfterFrom = availableLessons.slice(_.findIndex(availableLessons, ['slug', from]));
  }

  const nextAvailableLesson = lessonsAfterFrom.find(
    (l) => (hasSubscription ? !l.markedAsComplete : (!l.markedAsComplete && l.free)),
  );

  if (nextAvailableLesson) {
    if (trackSlug) nextAvailableLesson.trackSlug = trackSlug;
    return nextAvailableLesson;
  }

  // If all were markedAsComplete, try to loop back to beginning
  const firstAvailableLesson = hasSubscription
    ? availableLessons[0]
    : availableLessons.find((l) => l.free);
  if (firstAvailableLesson) {
    if (trackSlug) firstAvailableLesson.trackSlug = trackSlug;
    return firstAvailableLesson;
  }

  return null;
};

export const getNextLessonPath = (courses, lessonSlug, courseSlug, trackSlug) => {
  const course = courses.find((c) => c.slug === courseSlug);
  const courseIdx = courses.findIndex((c) => c.slug === courseSlug);
  const lessonIdx = course.lessons.findIndex((l) => l.slug === lessonSlug);
  const isEndOfCourse = lessonIdx === course.lessons.length - 1;

  let courseOfNextLesson;
  if (courseIdx > -1 && isEndOfCourse) {
    courseOfNextLesson = _.find(courses, (c) => !c.comingSoon, courseIdx + 1);
  } else {
    courseOfNextLesson = course;
  }

  if (!courseOfNextLesson || lessonIdx < 0) {
    return null;
  }

  if (courseOfNextLesson.slug === courseSlug && isEndOfCourse) {
    return null;
  }

  const nextLesson = isEndOfCourse
    ? courseOfNextLesson?.lessons[0] // first lesson in next course
    : course?.lessons[lessonIdx + 1];

  return trackSlug
    ? `/courses/${trackSlug}/${courseOfNextLesson.slug}/${nextLesson.slug}`
    : `/courses/${courseOfNextLesson.slug}/${nextLesson.slug}`;
};
